import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../components/Loader'
import UserCard from "../../components/UserCard"


//organization friends


const Friends = () => {
    const { organization } = useParams()

    const [friends, setFriends] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")
    const [hasMore,setHasMore] = useState(true)
    const [page, setPage] = useState(1)

    useEffect(() => {
        const getFriends = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/${organization}/friends`, { params: { page } })
                // console.log(response)
                if (response) {
                    setIsLoading(false)
                    setHasMore(response?.data >=20)
                    setFriends(response?.data)
                }
            } catch (error) {
                setIsLoading(false)
                setHasMore(false)
                toast.error(error.response?.data.message)
            }
            finally{
                setIsLoading(false)
            }
        }

        getFriends()
    }, [])

    const refresh = async () => { }

    return (
        <div>
            <h3 className="page-header-title">{organization}</h3><span>Friends</span>
            <div className="user-list">
                <InfiniteScroll
                    dataLength={friends?.length}
                    pullDownToRefresh={true}
                    loader={<Loader />}
                    hasMore= {hasMore}
                    refreshFunction={refresh}
                >
                    {isLoading && <Loader />}
                    {!isLoading && friends.length === 0 &&
                        <p className="not-found-msg">No friends found</p>
                    }
                    {
                        friends.length > 0 && friends.map((friend) => (
                            <UserCard key={friend._id} user={friend} />
                        ))
                    }
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default Friends